import { UnifiedButtonPDP as UnifiedButtonPDPProps, SanityKeyed } from 'types/studio/studio';
import { UnifiedButton, UnifiedButtonType } from '../../UnifiedButton';
import styles from './UnifiedButtonPDP.module.scss';
import { CommonSectionProps } from '../../types';

const UnifiedButtonPDP = (props: SanityKeyed<UnifiedButtonPDPProps> & CommonSectionProps) => {
  const { _key: key, unifiedButton } = props;

  return (
    <div id={key}>
      <UnifiedButton
        unifiedButton={unifiedButton as UnifiedButtonType}
        sectionType="unifiedButtonPDP"
        className={styles.unifiedButton}
        size="medium"
        theme="new"
      />
    </div>
  );
};

export default UnifiedButtonPDP;
